(() => {
  'use strict';
  
  // Isolate our code to prevent conflicts with Shopify's scripts
  // Use a unique namespace to avoid global pollution
  if (window.__CIPHEROWLS_INITIALIZED__) {
    return; // Prevent double initialization
  }
  window.__CIPHEROWLS_INITIALIZED__ = true;
  
  // Wrap in try-catch to prevent errors from breaking Shopify's scripts
  try {
  const state = {
    account: null,
    chainId: null,
    hasNft: false,
    checking: false,
    settings: {},
    walletConnect: null,
    walletConnectUnavailable: false,
    provider: null,
    connection: null,
  };

  const rpcCooldowns = new Map();

  const dom = {
    gateButton: () => document.querySelector("[data-co-gate-btn]"),
    gateStatus: () => document.querySelector("[data-co-gate-status]"),
    gatePanels: () => document.querySelectorAll("[data-co-gated]"),
    tabButtons: () => document.querySelectorAll("[data-co-tab-btn]"),
    tabPanels: () => document.querySelectorAll("[data-co-tab-panel]"),
  };

  function escapeHtml(str) {
    if (typeof str !== 'string') return '';
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function sanitizeUrl(url) {
    if (typeof url !== 'string') return '';
    var trimmed = url.trim();
    if (trimmed.startsWith('https://') || trimmed.startsWith('/') || trimmed.startsWith('data:image/')) return trimmed;
    return '';
  }

  function setStatus(text) {
    const el = dom.gateStatus();
    if (el) {
      // Replace newlines with line breaks using safe DOM methods
      el.textContent = '';
      text.split('\n').forEach((line, i) => {
        if (i > 0) el.appendChild(document.createElement('br'));
        el.appendChild(document.createTextNode(line));
      });
      
      // Add error styling and alert styling if it's an error message
      const alertContainer = el.closest('.co-alert');
      if (text.includes("⚠️") || text.includes("No wallet") || text.includes("No Solana wallet") || text.includes("failed") || text.includes("error") || text.includes("don't own")) {
        el.style.color = "var(--co-accent2)";
        el.style.fontWeight = "600";
        el.style.fontSize = "15px";
        if (alertContainer) {
          alertContainer.style.borderColor = "var(--co-accent2)";
          alertContainer.style.background = "rgba(47, 246, 210, 0.08)";
        }
      } else {
        el.style.color = "";
        el.style.fontWeight = "";
        el.style.fontSize = "";
        if (alertContainer) {
          alertContainer.style.borderColor = "";
          alertContainer.style.background = "";
        }
      }
    }
  }

  function showToast(message, type) {
    const container = document.getElementById('co-toast-container');
    if (!container) return;
    const toast = document.createElement('div');
    toast.className = 'co-toast' + (type ? ' co-toast-' + type : '');
    toast.textContent = message;
    container.appendChild(toast);
    setTimeout(() => {
      toast.classList.add('is-leaving');
      setTimeout(() => toast.remove(), 300);
    }, 4000);
  }

  function showSuccessMessage() {
    const existingMessage = document.querySelector('.co-gate-success-message');
    if (existingMessage) {
      existingMessage.remove();
    }
    
    const message = document.createElement('div');
    message.className = 'co-gate-success-message';
    message.textContent = '✨ Access Granted ✨';
    document.body.appendChild(message);
    
    // Show and then hide after animation
    setTimeout(() => {
      message.classList.add('show');
    }, 10);
    
    setTimeout(() => {
      message.style.animation = 'successPopup 0.5s ease-in reverse forwards';
      setTimeout(() => {
        message.remove();
      }, 500);
    }, 2000);
  }

  function showCustomOrderPopup() {
    try {
      if (sessionStorage.getItem('co-order-popup-shown')) return;
      sessionStorage.setItem('co-order-popup-shown', '1');
    } catch (e) {}

    const backdrop = document.createElement('div');
    backdrop.className = 'co-modal-backdrop';
    backdrop.style.cssText = 'z-index:10002;';
    backdrop.innerHTML =
      '<div class="co-modal-inner" style="max-width:520px;">' +
        '<button class="co-modal-close" id="co-order-popup-close">&times;</button>' +
        '<div style="margin-bottom:16px;">' +
          '<div style="font-size:22px;font-weight:800;margin-bottom:4px;">Welcome, Cipher Owl &#x1F989;</div>' +
          '<div class="co-muted" style="font-size:14px;">Your NFT is verified. Here\'s how to place a custom order.</div>' +
        '</div>' +
        '<div style="border:1px solid var(--co-border);border-radius:12px;padding:18px 20px;font-size:14px;line-height:1.75;background:rgba(255,255,255,.03);">' +
          '<p style="margin:0 0 14px;">To help us bring your NFT to life, please include the following in your email:</p>' +
          '<p style="margin:0 0 8px;"><strong>Subject Line:</strong> Custom Order - [Your NFT Name/ID #]</p>' +
          '<p style="margin:0 0 8px;"><strong>Proof of Ownership:</strong> A screenshot of your NFT in your wallet and your wallet address for verification.</p>' +
          '<p style="margin:0 0 8px;"><strong>Shipping Info:</strong> Your name and full shipping address so we can calculate any regional costs.</p>' +
          '<p style="margin:0 0 0;color:var(--co-muted);font-size:13px;padding-top:12px;border-top:1px solid var(--co-border);">Please Note: We will never process an order without your final consent. Please be very clear about your preferences, as these are custom-made products and <strong>cannot be returned or exchanged</strong> once produced.</p>' +
        '</div>' +
        '<a href="mailto:callie@cipherlabsx.com?subject=Custom%20Order%20-%20%5BYour%20NFT%20Name%2FID%20%23%5D" class="co-btn" style="margin-top:16px;width:100%;justify-content:center;display:flex;">Email callie@cipherlabsx.com</a>' +
      '</div>';

    document.body.appendChild(backdrop);

    function close() { backdrop.remove(); }
    backdrop.querySelector('#co-order-popup-close').addEventListener('click', close);
    backdrop.addEventListener('click', (e) => { if (e.target === backdrop) close(); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); }
    });
  }

  function toggleGatedContent(show) {
    dom.gatePanels().forEach((panel) => {
      const productsContainer = panel.querySelector('.co-gated-products');
      const connectBtn = panel.querySelector('[data-co-gate-btn]');
      if (show) {
        panel.removeAttribute("data-locked");
        panel.classList.add("is-active");
        if (connectBtn) connectBtn.style.display = 'none';
        if (productsContainer) {
          // Show container first
          productsContainer.style.display = 'block';
          
          // Trigger entrance animation
          setTimeout(() => {
            productsContainer.classList.add('revealing');
            
            // After reveal animation, add revealed class for product card animations
            setTimeout(() => {
              productsContainer.classList.remove('revealing');
              productsContainer.classList.add('revealed');
              
              // Show success message
              showSuccessMessage();
            }, 1200);
          }, 100);
        }
      } else {
        panel.setAttribute("data-locked", "true");
        panel.classList.remove("is-active");
        if (connectBtn) connectBtn.style.display = '';
        if (productsContainer) {
          productsContainer.classList.remove('revealing', 'revealed');
          productsContainer.style.display = 'none';
        }
      }
    });
  }

  async function loadSolanaWeb3() {
    if (window.__coVendor?.solanaWeb3) {
      window.solanaWeb3 = window.__coVendor.solanaWeb3;
      return window.solanaWeb3;
    }
    if (window.solanaWeb3) {
      return window.solanaWeb3;
    }
    throw new Error("Solana Web3 library not loaded. Ensure vendor.min.js is included in your theme assets.");
  }

  async function loadWalletConnectSolana() {
    if (window.__coVendor?.WalletConnectSolanaAdapter) {
      window.WalletConnectSolanaAdapter = window.__coVendor.WalletConnectSolanaAdapter;
      return true;
    }
    if (window.WalletConnectSolanaAdapter) {
      return true;
    }
    throw new Error("WalletConnect Solana adapter not loaded. Ensure vendor.min.js is included in your theme assets.");
  }

  async function initWalletConnect() {
    if (!state.settings.enableWalletConnect || !state.settings.walletConnectProjectId) {
      return null;
    }

    try {
      await loadSolanaWeb3();

      try {
        await loadWalletConnectSolana();
      } catch (loadErr) {
        return null;
      }

      await new Promise(resolve => setTimeout(resolve, 200));

      const solanaWeb3 = window.solanaWeb3;
      const WalletConnectAdapter = window.WalletConnectSolanaAdapter?.WalletConnectWalletAdapter ||
                                   window.WalletConnectSolanaAdapter?.default ||
                                   window.WalletConnectSolanaAdapter;

      if (!WalletConnectAdapter || !solanaWeb3) {
        return null;
      }

      const network = state.settings.nftChainId === "mainnet-beta" || state.settings.nftChainId === "mainnet"
        ? "mainnet-beta"
        : state.settings.nftChainId || "mainnet-beta";

      const adapter = new WalletConnectAdapter({
        network: network,
        options: {
          relayUrl: "wss://relay.walletconnect.com",
          projectId: state.settings.walletConnectProjectId,
        },
      });

      await adapter.connect();
      return adapter;
    } catch (err) {
      return null;
    }
  }

  async function ensureProvider() {
    if (state.provider) {
      return state.provider;
    }

    await new Promise(resolve => setTimeout(resolve, 100));

    const phantomIcon = (state.settings && state.settings.phantomIcon) || '';
    const solflareIcon = (state.settings && state.settings.solflareIcon) || '';

    const detected = [];

    // Phantom
    const phantomProvider = (window.solana?.isPhantom || window.solana?._phantom) ? window.solana
                          : window.phantom?.solana ? window.phantom.solana
                          : null;
    if (phantomProvider) {
      detected.push({
        name: 'Phantom',
        icon: phantomIcon,
        provider: phantomProvider,
      });
    }

    // Solflare
    const solflareProvider = window.solana?.isSolflare ? window.solana
                           : (window.solflare && typeof window.solflare.connect === 'function') ? window.solflare
                           : null;
    if (solflareProvider) {
      detected.push({
        name: 'Solflare',
        icon: solflareIcon,
        provider: solflareProvider,
      });
    }

    // Generic fallback (window.solana that isn't Phantom or Solflare)
    if (!detected.length && window.solana && typeof window.solana.connect === 'function') {
      detected.push({ name: 'Solana Wallet', icon: '', provider: window.solana });
    }

    // Retry after delay if nothing found yet
    if (!detected.length) {
      await new Promise(resolve => setTimeout(resolve, 500));
      if (window.solana?.isPhantom || window.phantom?.solana) {
        detected.push({ name: 'Phantom', icon: phantomIcon, provider: window.solana?.isPhantom ? window.solana : window.phantom.solana });
      }
      if (window.solana?.isSolflare || (window.solflare && typeof window.solflare.connect === 'function')) {
        detected.push({ name: 'Solflare', icon: solflareIcon, provider: window.solana?.isSolflare ? window.solana : window.solflare });
      }
    }

    // If exactly one wallet found, use it directly
    if (detected.length === 1) {
      return detected[0].provider;
    }

    // If multiple wallets found, show picker
    if (detected.length > 1) {
      const chosen = await showWalletPicker(detected);
      return chosen.provider;
    }

    // No browser wallets — try WalletConnect as last resort
    if (state.settings.enableWalletConnect && state.settings.walletConnectProjectId) {
      try {
        const wcProvider = await initWalletConnect();
        if (wcProvider) {
          state.provider = wcProvider;
          return wcProvider;
        }
      } catch (err) {
        // WalletConnect init failed, fall through to error
      }
    }

    throw new Error("No Solana wallet detected. To access Exclusive products, please:\n\n1. Install Phantom (phantom.app) or Solflare (solflare.com)\n2. Refresh this page\n3. Click 'Connect wallet' again");
  }

  function showWalletPicker(wallets) {
    return new Promise((resolve, reject) => {
      const backdrop = document.createElement('div');
      backdrop.className = 'co-modal-backdrop';
      backdrop.style.zIndex = '10003';
      const inner = document.createElement('div');
      inner.className = 'co-modal-inner';
      inner.style.maxWidth = '380px';
      inner.innerHTML =
        '<button class="co-modal-close" data-co-picker-close>&times;</button>' +
        '<h3 style="margin:0 0 4px;">Connect Wallet</h3>' +
        '<p class="co-muted" style="margin:0 0 4px;font-size:13px;">Choose a wallet to continue</p>' +
        '<div class="co-wallet-picker"></div>';

      const picker = inner.querySelector('.co-wallet-picker');
      wallets.forEach((w, i) => {
        const btn = document.createElement('button');
        btn.className = 'co-wallet-option';
        const safeIcon = sanitizeUrl(w.icon);
        btn.innerHTML =
          (safeIcon ? '<img src="' + escapeHtml(safeIcon) + '" alt="">' : '<div style="width:32px;height:32px;border-radius:8px;background:var(--co-border);display:grid;place-items:center;">?</div>') +
          '<div class="co-wallet-meta">' + escapeHtml(w.name) + '<span>Detected</span></div>';
        btn.addEventListener('click', () => { cleanup(); resolve(w); });
        picker.appendChild(btn);
      });

      backdrop.appendChild(inner);
      document.body.appendChild(backdrop);

      function cleanup() { backdrop.remove(); document.removeEventListener('keydown', onEsc); }
      function onEsc(e) { if (e.key === 'Escape') { cleanup(); reject(new Error('Connection cancelled')); } }
      document.addEventListener('keydown', onEsc);
      inner.querySelector('[data-co-picker-close]').addEventListener('click', () => { cleanup(); reject(new Error('Connection cancelled')); });
      backdrop.addEventListener('click', (e) => { if (e.target === backdrop) { cleanup(); reject(new Error('Connection cancelled')); } });
    });
  }

  async function connectWallet() {
    let provider;
    try {
      provider = await ensureProvider();
    } catch (err) {
      console.error("Failed to get wallet provider:", err);
      throw err; // Re-throw to be handled by handleGate
    }
    
    if (!provider) {
      throw new Error("No wallet provider available");
    }
    
    try {
      // Check if already connected
      if (provider.publicKey) {
        state.account = provider.publicKey.toString();
        state.chainId = state.settings.nftChainId || "mainnet-beta";
        return;
      }
      
      // Browser wallet (Phantom, Solflare, etc.) - ALWAYS try this FIRST
      // Check if it's a browser wallet (not WalletConnect adapter)
      // Browser wallets have isPhantom/isSolflare OR have connect but no publicKey property defined
      const isBrowserWallet = provider.isPhantom || 
                              provider.isSolflare || 
                              (provider.connect && typeof provider.connect === 'function' && !('publicKey' in provider));
      
      if (isBrowserWallet) {
        try {
          // Add timeout to prevent hanging
          const connectPromise = provider.connect({ onlyIfTrusted: false });
          const timeoutPromise = new Promise((_, reject) => {
            setTimeout(() => {
              reject(new Error("Connection timeout. Please make sure your wallet extension is unlocked and try again."));
            }, 30000); // 30 second timeout
          });
          
          const response = await Promise.race([connectPromise, timeoutPromise]);
          
          if (!response || !response.publicKey) {
            throw new Error("Connection failed: No public key received from wallet.");
          }
          
          state.account = response.publicKey.toString();
          state.chainId = state.settings.nftChainId || "mainnet-beta";

          // Set up disconnect handler
          if (provider.on && typeof provider.on === 'function') {
            provider.on("disconnect", () => {
              state.account = null;
              state.provider = null;
              window.location.reload();
            });
          }
          return;
        } catch (err) {
          console.error("Browser wallet connection error:", err);
          if (err.code === 4001) {
            throw new Error("Connection rejected. Please approve the connection request in your wallet.");
          }
          if (err.message && err.message.includes("timeout")) {
            throw err;
          }
          throw new Error(err.message || "Failed to connect wallet. Please make sure your wallet is unlocked and try again.");
        }
      }
      
      // WalletConnect adapter (fallback only - if we get here, browser wallet failed)
      // WalletConnect adapters have publicKey as a property (even if undefined)
      const isWalletConnect = provider.connect && 
                              typeof provider.connect === 'function' && 
                              'publicKey' in provider &&
                              !provider.isPhantom && 
                              !provider.isSolflare;
      
      if (isWalletConnect) {
        try {
          if (!provider.publicKey) {
            await provider.connect();
          }
          state.account = provider.publicKey.toString();
          state.chainId = state.settings.nftChainId || "mainnet-beta";
          return;
        } catch (err) {
          console.error("WalletConnect connection failed", err);
          throw new Error("WalletConnect connection failed. Please use Phantom wallet (phantom.app) or another browser wallet extension instead.");
        }
      }
      
      // Fallback: try generic connect
      try {
        const response = await provider.connect();
        if (response && response.publicKey) {
          state.account = response.publicKey.toString();
        } else if (provider.publicKey) {
          state.account = provider.publicKey.toString();
        } else {
          throw new Error("Connection failed: No public key received from wallet.");
        }
        state.chainId = state.settings.nftChainId || "mainnet-beta";
        
        if (!state.account) {
          throw new Error("Connection failed: No account address received.");
        }
      } catch (genericErr) {
        console.error("Generic connection failed:", genericErr);
        throw new Error(`Wallet connection failed: ${genericErr.message || "Unknown error"}. Please make sure your wallet is unlocked and try again.`);
      }
    } catch (err) {
      console.error("Wallet connection error:", err);
      // If it's already a user-friendly error, re-throw as-is
      if (err.message && (err.message.includes("No Solana wallet") || 
                          err.message.includes("Connection rejected") || 
                          err.message.includes("timeout") ||
                          err.message.includes("Failed to connect"))) {
        throw err;
      }
      // Otherwise, wrap in a user-friendly message
      throw new Error(`Failed to connect wallet: ${err.message || err.toString() || "Unknown error"}. Please make sure your wallet extension is installed and unlocked.`);
    }
  }

  async function getNftMetadata(mintAddress, connection) {
    try {
      const { PublicKey } = await loadSolanaWeb3();
      const mintPublicKey = new PublicKey(mintAddress);
      
      // Metaplex Metadata Program ID
      const METADATA_PROGRAM_ID = new PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s");
      
      // Derive metadata PDA (Program Derived Address)
      const [metadataPDA] = PublicKey.findProgramAddressSync(
        [
          Buffer.from("metadata"),
          METADATA_PROGRAM_ID.toBuffer(),
          mintPublicKey.toBuffer(),
        ],
        METADATA_PROGRAM_ID
      );
      
      // Get account info
      const accountInfo = await connection.getAccountInfo(metadataPDA);
      if (!accountInfo) {
        return null;
      }
      
      // Parse metadata (simplified - full parsing would use Metaplex SDK)
      // The collection info is stored in the metadata account
      return {
        mint: mintAddress,
        metadataAccount: metadataPDA.toString(),
        accountInfo: accountInfo
      };
    } catch (err) {
      console.error("Error getting NFT metadata:", err);
      return null;
    }
  }

  // Helius DAS API verification via server-side proxy (recommended - keeps API key secure)
  async function checkNftOwnershipHelius() {
    const nftMintAddress = state.settings.nftContractAddress || "3Yqemc88mnNhQvUEW4NJMU7R93ap6ZCwLX5HzqJWZMJH";
    
    if (!state.account) {
      throw new Error("Wallet not connected. Please connect your wallet first.");
    }
    
    if (!nftMintAddress || nftMintAddress.trim() === "") {
      throw new Error("NFT collection address not configured. Please contact support.");
    }

    const apiEndpoint = state.settings.apiEndpoint;
    if (!apiEndpoint) {
      throw new Error("API endpoint not configured for Helius verification.");
    }
    
    try {
      const response = await fetch(`${apiEndpoint}/api/helius-check`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          wallet: state.account,
          nftMint: nftMintAddress,
        }),
      });
      
      if (!response.ok) {
        if (response.status === 429) {
          throw new Error("Rate limited. Please try again in a moment.");
        }
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Helius proxy error: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.hasAccess) {
        state.hasNft = true;
        return true;
      } else {
        state.hasNft = false;
        return false;
      }
    } catch (err) {
      console.error("Helius NFT verification error:", err);
      throw new Error(`NFT verification failed: ${err.message || "Unknown error"}. Please try again or contact support.`);
    }
  }

  // Get bs58 encoder (from vendor bundle or Solana Web3.js)
  async function getBs58() {
    if (window.__coVendor?.bs58) {
      window.bs58 = window.__coVendor.bs58;
      return window.bs58;
    }
    if (window.bs58) {
      return window.bs58;
    }

    // Check if Solana Web3.js has bs58 bundled
    if (window.solanaWeb3) {
      try {
        if (window.solanaWeb3.bs58) {
          window.bs58 = window.solanaWeb3.bs58;
          return window.bs58;
        }
        const utils = window.solanaWeb3.utils || window.solanaWeb3;
        if (utils && utils.bs58) {
          window.bs58 = utils.bs58;
          return window.bs58;
        }
      } catch (e) {
        // bs58 not available via solanaWeb3
      }
    }

    throw new Error("bs58 library not loaded. Ensure vendor.min.js is included in your theme assets.");
  }

  // Generate wallet signature for API authentication
  // Matches backend canonical message format in lib/auth.ts
  async function generateWalletSignature(walletPublicKey, apiEndpoint) {
    const walletProvider = state.provider || window.solflare || window.solana;
    if (!walletProvider || !walletProvider.isConnected) {
      throw new Error("Wallet not connected");
    }
    
    const timestamp = Date.now().toString();
    const wallet = walletPublicKey.toString();
    
    let host, path, method;
    try {
      const url = new URL(apiEndpoint);
      host = url.host;
      path = "/api/verify";
      method = "POST";
    } catch (err) {
      throw new Error(`Invalid API endpoint: ${apiEndpoint}`);
    }
    
    const message = [
      'CipherDAO - NFT Auth',
      `Host: ${host}`,
      `Method: ${method.toUpperCase()}`,
      `Path: ${path}`,
      `Wallet: ${wallet}`,
      `Timestamp: ${timestamp}`,
    ].join('\n');
    
    try {
      const bs58Lib = await getBs58();
      
      if (!bs58Lib) {
        throw new Error("bs58 library not available");
      }
      
      const encodedMessage = new TextEncoder().encode(message);
      const signedMessage = await walletProvider.signMessage(encodedMessage, "utf8");
      
      // Convert signature to base58
      if (typeof signedMessage.signature === "object" && signedMessage.signature.length) {
        const sigBase58 = bs58Lib.encode(signedMessage.signature);
        return {
          signature: sigBase58,
          timestamp: timestamp,
          message: message
        };
      }
      throw new Error("Invalid signature format");
    } catch (err) {
      console.error("Signature generation error:", err);
      throw new Error(`Failed to generate signature: ${err.message}`);
    }
  }

  // Check NFT ownership via backend API
  async function checkNftOwnershipAPI() {
    const apiEndpoint = state.settings.apiEndpoint;
    if (!apiEndpoint) {
      throw new Error("API endpoint not configured");
    }

    const wallet = state.account;
    if (!wallet) {
      throw new Error("Wallet not connected");
    }

    try {
      // Generate signature
      const sigData = await generateWalletSignature(wallet, apiEndpoint);
      
      // Make API request
      const response = await fetch(`${apiEndpoint}/api/verify`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-wallet": wallet,
          "x-sig": sigData.signature,
          "x-ts": sigData.timestamp,
        },
      });

      if (!response.ok) {
        if (response.status === 429) {
          throw new Error("Rate limited. Please try again in a moment.");
        }
        if (response.status === 401) {
          throw new Error("Authentication failed. Please reconnect your wallet.");
        }
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `API error: ${response.status}`);
      }

      const data = await response.json();
      return {
        hasAccess: data.hasAccess === true,
        owlCount: data.owlCount || 0,
        wallet: data.wallet || wallet,
      };
    } catch (err) {
      console.error("API NFT verification error:", err);
      throw err;
    }
  }

  // Main NFT ownership check - routes to appropriate method
  async function checkNftOwnership() {
    // Prioritize API if endpoint is configured
    if (state.settings.apiEndpoint) {
      try {
        const result = await checkNftOwnershipAPI();
        // Normalize return value: API returns object, others return boolean
        return result.hasAccess === true;
      } catch (err) {
        // API failed, fall through to direct methods
      }
    }
    
    const method = state.settings.nftVerificationMethod || "helius";
    
    if (method === "helius") {
      return await checkNftOwnershipHelius();
    } else {
      return await checkNftOwnershipRPC();
    }
  }

  // Original RPC-based verification (fallback)
  async function checkNftOwnershipRPC() {
    // Use the CipherOwl collection address for verification
    const nftMintAddress = state.settings.nftContractAddress || "3Yqemc88mnNhQvUEW4NJMU7R93ap6ZCwLX5HzqJWZMJH";
    
    if (!state.account) {
      throw new Error("Wallet not connected. Please connect your wallet first.");
    }
    
    if (!nftMintAddress || nftMintAddress.trim() === "") {
      throw new Error("NFT collection address not configured. Please contact support.");
    }

    try {
      // Load Solana Web3
      const solanaWeb3 = await loadSolanaWeb3();
      const { Connection, PublicKey } = solanaWeb3;
      
      // Validate mint address format before making RPC calls
      try {
        const testMint = new PublicKey(nftMintAddress);
      } catch (validationErr) {
        throw new Error("Invalid NFT mint address format. Please check the configuration.");
      }
      
      // Get network
      const network = state.settings.nftChainId === "mainnet-beta" || state.settings.nftChainId === "mainnet"
        ? "mainnet-beta"
        : state.settings.nftChainId || "mainnet-beta";
      
      // Use multiple RPC endpoints with fallback (free public endpoints, no API key required)
      // Ordered by reliability - most reliable first
      // Note: Some endpoints may have CORS restrictions - they will be skipped automatically
      const rpcEndpoints = network === "mainnet-beta" 
        ? [
            "https://solana-rpc.publicnode.com", // Allnodes - free, no API key, most reliable, CORS-friendly
            "https://rpc.ankr.com/solana", // Ankr - free tier available, CORS-friendly
            "https://solana.drpc.org", // dRPC - free public endpoint, CORS-friendly
            "https://solana.lavenderfive.com", // Lavender.Five - free public, CORS-friendly
            "https://api.mainnet-beta.solana.com", // Official (rate-limited, CORS-friendly)
            "https://rpc.solanatracker.io", // SolanaTracker - free public endpoint
            "https://solana-mainnet.g.alchemy.com/v2/demo", // Alchemy demo endpoint (rate-limited)
            // Removed OnFinality - has CORS issues from browser
          ]
        : network === "devnet"
        ? [
            "https://api.devnet.solana.com",
            "https://solana-devnet-rpc.publicnode.com",
          ]
        : [
            "https://api.testnet.solana.com",
            "https://solana-testnet-rpc.publicnode.com",
          ];
      
      const ownerPublicKey = new PublicKey(state.account);
      const nftMint = new PublicKey(nftMintAddress);
      
      // Try each RPC endpoint until one works, with retry logic
      let lastError = null;
      let tokenAccounts = null;
      const maxRetries = 0; // Don't retry validation errors - skip immediately (1 total attempt per endpoint)
      
      for (const rpcUrl of rpcEndpoints) {
        // Skip endpoints in cooldown
        const cooldownUntil = rpcCooldowns.get(rpcUrl);
        if (cooldownUntil && cooldownUntil > Date.now()) {
          continue;
        }

        let retryCount = 0;
        let success = false;
        
        if (rpcEndpoints.indexOf(rpcUrl) > 0) {
          await new Promise(resolve => setTimeout(resolve, 200));
        }
        
        while (retryCount <= maxRetries && !success) {
          try {
            if (retryCount > 0) {
              // Wait before retry with exponential backoff
              const delay = Math.min(1000 * Math.pow(2, retryCount - 1), 5000);
              await new Promise(resolve => setTimeout(resolve, delay));
            }
            
            const connection = new Connection(rpcUrl, "confirmed");
            
            // Try the actual NFT check with this endpoint
            const result = await connection.getParsedTokenAccountsByOwner(ownerPublicKey, {
              mint: nftMint,
            });
            
            tokenAccounts = result;
            success = true;
            break;
          } catch (rpcErr) {
            // Extract error message from various possible formats
            let errorMsg = rpcErr.message || String(rpcErr);
            let errorCode = null;
            let errorJson = null;
            
            // Try to extract error code and JSON from error message
            try {
              // Check if error message contains JSON
              const jsonMatch = errorMsg.match(/\{.*\}/);
              if (jsonMatch) {
                errorJson = JSON.parse(jsonMatch[0]);
                if (errorJson.error) {
                  errorCode = errorJson.error.code || errorJson.error.rest_code;
                  errorMsg = errorJson.error.message || errorMsg;
                }
              }
              // Also check for "403 :" or "429 :" pattern
              const codeMatch = errorMsg.match(/(\d{3})\s*:/);
              if (codeMatch) {
                errorCode = parseInt(codeMatch[1]);
              }
            } catch (e) {
              // Ignore JSON parse errors
            }
            
            // Normalize error message to lowercase for easier matching
            const errorMsgLower = errorMsg.toLowerCase();
            
            // Check for CORS errors first - these should skip immediately
            const isCorsError = errorMsg && (
              errorMsg.includes("CORS") ||
              errorMsg.includes("blocked by CORS policy") ||
              errorMsg.includes("Access to fetch") ||
              errorMsg.includes("preflight request") ||
              (rpcErr.name === "TypeError" && errorMsg.includes("fetch")) ||
              errorMsg.includes("ERR_FAILED") && errorMsgLower.includes("cors")
            );
            
            // Check for network errors that might be CORS-related
            const isNetworkError = errorMsg && (
              errorMsg.includes("Failed to fetch") ||
              errorMsg.includes("NetworkError") ||
              errorMsg.includes("ERR_FAILED") ||
              errorMsg.includes("ERR_CONNECTION_REFUSED") ||
              (rpcErr.name === "TypeError" && errorMsg.includes("fetch"))
            );
            
            lastError = rpcErr;

            // CORS errors are permanent for browser requests - skip immediately
            if (isCorsError) {
              break;
            }
            
            // If it's an invalid public key error, don't retry - it's a configuration issue
            if (errorMsg && errorMsg.includes("Invalid public key")) {
              throw new Error("Invalid NFT address configured. Please contact support.");
            }
            
            // If it's a token mint unpacking error, don't retry - it's a validation/configuration issue
            // Check for various forms of this error (case-insensitive)
            const isTokenMintError = errorMsgLower && (
              errorMsgLower.includes("token mint could not be unpacked") ||
              errorMsgLower.includes("could not be unpacked") ||
              errorMsgLower.includes("invalid param") ||
              errorMsgLower.includes("mint could not be unpacked") ||
              (errorMsgLower.includes("unpacked") && errorMsgLower.includes("mint"))
            );
            
            if (isTokenMintError) {
              break; // Move to next endpoint - don't retry validation errors
            }
            
            // Distinguish between permanent (403) and temporary (429) errors
            // Check both error code and error message (case-insensitive)
            const is403 = errorCode === 403 || (errorMsgLower && (errorMsgLower.includes("403") || errorMsgLower.includes("access forbidden") || errorMsgLower.includes("api key is not allowed")));
            const is429 = errorCode === 429 || (errorMsgLower && (errorMsgLower.includes("429") || errorMsgLower.includes("too many requests")));
            const isRateLimit = is429 || (errorMsgLower && (errorMsgLower.includes("rate limit")));
            
            
            if (is403) {
              rpcCooldowns.set(rpcUrl, Date.now() + 300000); // 5 min cooldown for 403
              break;
            }
            
            if (is429 && retryCount < maxRetries) {
              retryCount++;
              continue;
            } else if (is429) {
              rpcCooldowns.set(rpcUrl, Date.now() + 60000); // 60s cooldown for 429
              break;
            }
            
            // Network errors (non-CORS) - might be temporary, but don't retry too many times
            if (isNetworkError && !isCorsError) {
              if (retryCount >= 1) {
                break;
              }
            }
            
            // For other errors, retry once then move on
            if (retryCount < maxRetries) {
              retryCount++;
              continue;
            } else {
              break; // Move to next endpoint
            }
          }
        }
        
        if (success) {
          break; // Found working endpoint
        }
      }
      
      // Check if we got a successful result
      if (tokenAccounts !== null) {
        if (tokenAccounts.value.length > 0) {
          state.hasNft = true;
          return true;
        } else {
          state.hasNft = false;
          return false;
        }
      }
      
      // If all endpoints failed, throw an error with helpful message
      if (lastError) {
        // Check if all errors were rate limits
        const allRateLimited = lastError.message && (
          lastError.message.includes("403") || 
          lastError.message.includes("429") ||
          lastError.message.includes("Access forbidden") || 
          lastError.message.includes("rate limit") ||
          lastError.message.includes("Too Many Requests") ||
          lastError.message.includes("API key")
        );
        
        if (allRateLimited) {
          throw new Error("All RPC endpoints are currently rate-limited. This is temporary. Please wait 1-2 minutes and try again. Free public RPCs have rate limits to prevent abuse.");
        }
        
        // Check if all endpoints failed due to CORS
        const allCorsErrors = rpcEndpoints.every((url, idx) => {
          // This is a heuristic - if we tried all endpoints and got network/CORS errors, likely all have CORS issues
          return lastError && (
            lastError.message && (
              lastError.message.includes("CORS") ||
              lastError.message.includes("blocked by CORS") ||
              lastError.message.includes("Failed to fetch") ||
              lastError.message.includes("ERR_FAILED")
            )
          );
        });
        
        if (allCorsErrors || (lastError.message && (lastError.message.includes("CORS") || lastError.message.includes("blocked by CORS policy")))) {
          throw new Error("⚠️ CORS error: RPC endpoints are blocking browser requests.\n\nThis is a known issue with some Solana RPC providers.\n\n💡 Solution: Use a Solana RPC provider that supports CORS, or contact support for a custom RPC endpoint.");
        }
        
        if (lastError.message && (lastError.message.includes("fetch") || lastError.message.includes("network") || lastError.message.includes("Failed to fetch"))) {
          throw new Error("Network error. Please check your internet connection and try again.");
        }
      }
      
      throw new Error("Unable to verify NFT ownership. All RPC endpoints failed. Please wait 1-2 minutes and try again. If the issue persists, contact support.");
    } catch (err) {
      console.error("NFT ownership check failed", err);
      
      // Return user-friendly error messages
      if (err.message && err.message.includes("Invalid public key")) {
        throw new Error("Invalid NFT address. Please contact support.");
      }
      if (err.message && err.message.includes("Wallet not connected")) {
        throw err; // Re-throw wallet connection errors as-is
      }
      if (err.message && err.message.includes("RPC endpoint")) {
        throw err; // Re-throw RPC errors as-is
      }
      if (err.message && err.message.includes("rate limited")) {
        throw err; // Re-throw rate limit errors as-is
      }
      if (err.message && err.message.includes("Network error")) {
        throw err; // Re-throw network errors as-is
      }
      
      // Generic error
      throw new Error("Failed to verify NFT ownership. Please check your wallet and try again.");
    }
  }

  async function handleGate() {
    if (state.checking) return;

    // SECURITY NOTE: NFT gating is a UX layer only. Exclusive products are
    // rendered in the page source and hidden via CSS/JS. A determined user can
    // bypass this by manipulating sessionStorage or the DOM. True access control
    // requires server-side enforcement (e.g. Shopify Liquid metafields set by
    // a backend verification API).
    //
    // Session cache: skip re-verification if already verified this session
    try {
      const cached = sessionStorage.getItem('co-nft-verified');
      if (cached && cached === 'pending') {
        // still loading from a previous attempt
      } else if (cached) {
        state.account = cached;
        state.hasNft = true;
        toggleGatedContent(true);
        setStatus("Access granted – your owl is verified.");
        showDisconnectBtn(true);
        return;
      }
    } catch (e) {}
    
    state.checking = true;
    setStatus("Connecting wallet…");

    // Show skeleton on gated products while verifying
    const gatedContainer = document.querySelector('.co-gated-products');
    if (gatedContainer) gatedContainer.classList.add('co-skeleton-active');
    
    try {
      await connectWallet();
      showToast('Wallet connected', 'success');
      showDisconnectBtn(true);
      
      setStatus("Verifying NFT ownership…");
      const ok = await checkNftOwnership();
      if (ok) {
        setStatus("Access granted – your owl is verified.");
        toggleGatedContent(true);
        showToast('NFT verified — access granted!', 'success');
        try { sessionStorage.setItem('co-nft-verified', state.account); } catch (e) {}
        setTimeout(() => showCustomOrderPopup(), 1800);
      } else {
        setStatus("You don't own the required CipherOwl NFT. This wallet doesn't have access to Exclusive products.");
        toggleGatedContent(false);
      }
    } catch (err) {
      console.error("Gate error:", err);
      console.error("Error stack:", err?.stack);
      console.error("Error details:", {
        name: err?.name,
        message: err?.message,
        code: err?.code,
        toString: err?.toString()
      });
      
      let errorMessage = err?.message || err?.toString() || "Could not verify wallet.";
      
      // User cancelled the wallet picker — silently reset, no error
      if (errorMessage.includes("Connection cancelled")) {
        setStatus("Connect your wallet to unlock Exclusive merch.");
        return;
      }

      if (errorMessage.includes("No wallet found") || errorMessage.includes("No Solana wallet detected")) {
        errorMessage = "⚠️ No Solana wallet detected\n\n📥 To access Exclusive products:\n\n1️⃣ Install Phantom (phantom.app) or Solflare (solflare.com)\n2️⃣ Refresh this page\n3️⃣ Click 'Connect wallet' again";
      } else if (errorMessage.includes("Connection rejected") || err?.code === 4001) {
        errorMessage = "Connection rejected. Please approve the connection request in your wallet.";
      } else if (errorMessage.includes("timeout") || errorMessage.includes("Connection timeout")) {
        errorMessage = "Connection timeout. Please make sure your wallet is unlocked and try again.";
      } else if (errorMessage.includes("don't own") || errorMessage.includes("doesn't have")) {
        // Keep the NFT ownership message as-is
        errorMessage = errorMessage;
      } else if (errorMessage.includes("Failed to connect") || errorMessage.includes("WalletConnect connection failed")) {
        errorMessage = "Failed to connect wallet. Please make sure your wallet is unlocked and try again. If using WalletConnect, try using Phantom wallet instead.";
      } else if (errorMessage.includes("rate limited") || errorMessage.includes("RPC endpoint") || errorMessage.includes("RPC endpoints are currently")) {
        errorMessage = "⚠️ Service temporarily unavailable\n\nAll RPC endpoints are rate-limited.\n\n⏱️ Please wait 1-2 minutes and try again.\n\n💡 Free public RPCs have rate limits. This is temporary.";
      } else if (errorMessage.includes("Network error")) {
        errorMessage = "Network error. Please check your internet connection and try again.";
      } else if (errorMessage.includes("All RPC endpoints failed")) {
        errorMessage = "Service temporarily unavailable. Please try again in a few moments.";
      } else if (errorMessage.includes("CDN_LOAD_FAILED")) {
        errorMessage = "⚠️ Wallet connection unavailable\n\nRequired libraries could not be loaded. This may be due to a network issue or ad blocker.\n\nPlease try:\n1. Disabling ad blockers for this site\n2. Checking your internet connection\n3. Refreshing the page and trying again";
      } else if (errorMessage.includes("TypeError") || errorMessage.includes("Cannot read") || errorMessage.includes("undefined")) {
        errorMessage = "⚠️ Script error detected\n\nPlease refresh the page and try again.\n\nIf the problem persists, check the browser console for details.";
      } else {
        // For any other unexpected error, show a helpful message
        errorMessage = `⚠️ Connection error\n\n${errorMessage}\n\nPlease try:\n1. Refreshing the page\n2. Making sure your wallet is unlocked\n3. Checking the browser console for details`;
      }
      
      setStatus(errorMessage);
      showToast('Connection failed', 'error');
      toggleGatedContent(false);
    } finally {
      state.checking = false;
      if (gatedContainer) gatedContainer.classList.remove('co-skeleton-active');
      // gate check completed
    }
  }

  function showDisconnectBtn(visible) {
    const btn = document.querySelector('[data-co-disconnect-btn]');
    if (btn) btn.classList.toggle('is-visible', visible);
  }

  function disconnectWallet() {
    state.account = null;
    state.provider = null;
    state.hasNft = false;
    try { sessionStorage.removeItem('co-nft-verified'); sessionStorage.removeItem('co-order-popup-shown'); } catch (e) {}
    toggleGatedContent(false);
    showDisconnectBtn(false);
    const connectBtn = dom.gateButton();
    if (connectBtn) connectBtn.style.display = '';
    setStatus("Connect your wallet to unlock Exclusive merch.");
    showToast('Wallet disconnected', 'success');
  }

  function initTabs() {
    const buttons = dom.tabButtons();
    const panels = dom.tabPanels();
    if (!buttons.length || !panels.length) return;

    function activateTab(target) {
      buttons.forEach((b) => b.classList.toggle("is-active", b.getAttribute("data-co-tab-btn") === target));
      panels.forEach((p) => p.classList.toggle("is-active", p.getAttribute("data-co-tab-panel") === target));
      try { sessionStorage.setItem("co-active-tab", target); } catch (e) {}
      const url = new URL(window.location);
      url.searchParams.set("tab", target);
      history.replaceState(null, "", url);
    }

    // Restore active tab from URL ?tab= param, hash anchor, or sessionStorage
    const params = new URLSearchParams(window.location.search);
    const hash = window.location.hash.replace("#", "");
    const savedTab = (() => { try { return sessionStorage.getItem("co-active-tab"); } catch (e) { return null; } })();
    const initialTab = params.get("tab") || (hash === "exclusive" || hash === "general" ? hash : null) || savedTab;
    // Always activate so the default (general) is correctly set in sessionStorage and URL
    activateTab(initialTab || "general");

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        activateTab(btn.getAttribute("data-co-tab-btn"));
      });
    });

    // Intercept pagination links to preserve the active tab param
    document.querySelectorAll(".co-pagination a").forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const linkUrl = new URL(link.href, window.location.origin);
        const activeTab = new URLSearchParams(window.location.search).get("tab") || sessionStorage.getItem("co-active-tab") || "general";
        linkUrl.searchParams.set("tab", activeTab);
        window.location.href = linkUrl.toString();
      });
    });
  }

  function bootstrapSettings() {
    const el = document.querySelector("[data-co-settings]");
    if (!el) return;
    try {
      const json = JSON.parse(el.textContent || "{}");
      state.settings = {
        nftContractAddress: (json.nftContractAddress || "").trim(),
        nftChainId: json.nftChainId || "mainnet-beta",
        enableWalletConnect: json.enableWalletConnect || false,
        walletConnectProjectId: (json.walletConnectProjectId || "").trim(),
        nftVerificationMethod: json.nftVerificationMethod || "helius",
        apiEndpoint: (json.apiEndpoint || "").trim(),
        phantomIcon: (json.phantomIcon || "").trim(),
        solflareIcon: (json.solflareIcon || "").trim(),
      };
    } catch (e) {
      console.error("Settings parse failed", e);
    }
  }

  // ── Mobile nav toggle ──
  function initMobileNav() {
    const toggle = document.querySelector('[data-co-nav-toggle]');
    const nav = document.querySelector('.co-nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', () => nav.classList.toggle('is-open'));
    document.addEventListener('click', (e) => {
      if (!nav.contains(e.target)) nav.classList.remove('is-open');
    });
  }

  // ── Disconnect wallet ──
  function initDisconnect() {
    const btn = document.querySelector('[data-co-disconnect-btn]');
    if (btn) btn.addEventListener('click', disconnectWallet);
  }

  // ── Cart drawer ──
  function initCartDrawer() {
    const drawer = document.getElementById('co-cart-drawer');
    const backdrop = document.querySelector('[data-co-drawer-backdrop]');
    const closeBtn = drawer?.querySelector('[data-co-drawer-close]');
    const cartToggle = document.querySelector('[data-co-cart-toggle]');
    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.classList.add('is-open');
      refreshDrawerCart();
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (backdrop) backdrop.classList.remove('is-open');
    }

    if (cartToggle) {
      cartToggle.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    function refreshDrawerCart() {
      fetch('/cart.js').then(r => r.json()).then(cart => {
        const body = drawer.querySelector('[data-co-drawer-body]');
        if (!body) return;
        if (!cart.items.length) {
          body.innerHTML = '<div class="co-drawer-empty co-muted">Your cart is empty.</div>';
          return;
        }
        body.innerHTML = cart.items.map(item => {
          const safeImg = sanitizeUrl((item.image || '').replace(/(\.\w+)$/, '_100x100$1'));
          return '<div class="co-drawer-item">' +
            (safeImg ? '<img src="' + escapeHtml(safeImg) + '" alt="">' : '') +
            '<div class="co-drawer-item-info">' +
              '<div style="font-weight:700;">' + escapeHtml(item.product_title) + '</div>' +
              (item.variant_title ? '<div class="co-muted">' + escapeHtml(item.variant_title) + '</div>' : '') +
              '<div class="co-muted">' + parseInt(item.quantity) + ' \u00d7 ' + (item.price / 100).toFixed(2) + ' ' + escapeHtml(cart.currency) + '</div>' +
            '</div>' +
          '</div>';
        }).join('');
      }).catch(() => {});
    }

    // Intercept add-to-cart forms
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
      }).then(r => r.json()).then(() => {
        openDrawer();
        showToast('Added to cart', 'success');
      }).catch(() => showToast('Could not add to cart', 'error'));
    });
  }

  // ── Quick-view modal ──
  function initQuickView() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-co-quickview]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const url = btn.getAttribute('data-co-quickview');
      if (!url) return;

      fetch(url).then(r => r.json()).then(product => {
        const safeImg = sanitizeUrl(product.images?.[0] ? product.images[0].replace(/(\.\w+)$/, '_600x600$1') : '');
        const variants = product.variants || [];
        const variantOptions = variants.map(v =>
          '<option value="' + escapeHtml(String(v.id)) + '"' + (!v.available ? ' disabled' : '') + '>' + escapeHtml(v.title) + ' \u2014 ' + (v.price / 100).toFixed(2) + '</option>'
        ).join('');

        const modal = document.createElement('div');
        modal.className = 'co-modal-backdrop';
        modal.innerHTML =
          '<div class="co-modal-inner">' +
            '<button class="co-modal-close">&times;</button>' +
            (safeImg ? '<img class="co-modal-img" src="' + escapeHtml(safeImg) + '" alt="">' : '') +
            '<h2 style="margin:0 0 4px;">' + escapeHtml(product.title) + '</h2>' +
            '<div class="co-muted" style="margin-bottom:12px;">' + escapeHtml(product.vendor) + '</div>' +
            '<div class="co-price" style="font-size:20px;margin-bottom:16px;">' + (product.price / 100).toFixed(2) + ' ' + (product.price_varies ? '+' : '') + '</div>' +
            (product.description ? '<div class="co-muted" style="margin-bottom:16px;font-size:13px;max-height:120px;overflow-y:auto;">' + escapeHtml(product.description.substring(0, 400)) + '</div>' : '') +
            '<form action="/cart/add" method="post">' +
              (variants.length > 1 ? '<select name="id" class="co-sort-select" style="width:100%;margin-bottom:12px;">' + variantOptions + '</select>' : '<input type="hidden" name="id" value="' + escapeHtml(String(variants[0]?.id)) + '">') +
              '<button type="submit" class="co-btn" style="width:100%;justify-content:center;">Add to cart</button>' +
            '</form>' +
          '</div>';

        document.body.appendChild(modal);
        modal.querySelector('.co-modal-close').addEventListener('click', () => modal.remove());
        modal.addEventListener('click', (ev) => { if (ev.target === modal) modal.remove(); });
        document.addEventListener('keydown', function esc(ev) {
          if (ev.key === 'Escape') { modal.remove(); document.removeEventListener('keydown', esc); }
        });
      }).catch(() => showToast('Could not load product', 'error'));
    });
  }

  // ── Sort / filter ──
  function initSort() {
    document.querySelectorAll('[data-co-sort]').forEach(select => {
      select.addEventListener('change', () => {
        const panel = select.closest('.co-tab-panel') || select.closest('.co-gated-products');
        if (!panel) return;
        const grid = panel.querySelector('.co-products');
        if (!grid) return;
        const cards = Array.from(grid.querySelectorAll('.co-product-card'));
        const val = select.value;
        if (val === 'default') return;
        cards.sort((a, b) => {
          if (val === 'price-asc') return (parseFloat(a.dataset.coPrice) || 0) - (parseFloat(b.dataset.coPrice) || 0);
          if (val === 'price-desc') return (parseFloat(b.dataset.coPrice) || 0) - (parseFloat(a.dataset.coPrice) || 0);
          if (val === 'alpha') return (a.dataset.coTitle || '').localeCompare(b.dataset.coTitle || '');
          return 0;
        });
        cards.forEach(c => grid.appendChild(c));
      });
    });
  }

  // ── Wishlist ──
  function initWishlist() {
    function getList() {
      try { return JSON.parse(localStorage.getItem('co-wishlist') || '[]'); } catch (e) { return []; }
    }
    function saveList(list) {
      try { localStorage.setItem('co-wishlist', JSON.stringify(list)); } catch (e) {}
    }
    function refresh() {
      const list = getList();
      document.querySelectorAll('[data-co-wishlist]').forEach(btn => {
        const id = btn.getAttribute('data-co-wishlist');
        const saved = list.includes(id);
        btn.classList.toggle('is-saved', saved);
        btn.innerHTML = saved ? '&#9829;' : '&#9825;';
      });
    }
    refresh();
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-co-wishlist]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const id = btn.getAttribute('data-co-wishlist');
      let list = getList();
      if (list.includes(id)) {
        list = list.filter(x => x !== id);
        showToast('Removed from wishlist', '');
      } else {
        list.push(id);
        showToast('Saved to wishlist', 'success');
      }
      saveList(list);
      refresh();
    });
  }

  // ── Typewriter effect on hero heading ──
  function initTypewriter() {
    var el = document.querySelector('[data-co-typewriter]');
    if (!el) return;
    var text = el.textContent.trim();
    el.textContent = '';
    el.classList.add('co-typing-cursor');
    var i = 0;
    function type() {
      if (i < text.length) {
        el.textContent += text[i];
        i++;
        setTimeout(type, 60 + Math.random() * 40);
      } else {
        setTimeout(function() { el.classList.remove('co-typing-cursor'); }, 1500);
      }
    }
    setTimeout(type, 400);
  }

  // ── Cipher text decode animation ──
  function initCipherDecode() {
    var els = document.querySelectorAll('[data-co-cipher]');
    if (!els.length) return;
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';
    els.forEach(function(el) {
      var original = el.textContent.trim();
      var length = original.length;
      var scrambled = '';
      for (var i = 0; i < length; i++) {
        scrambled += original[i] === ' ' ? ' ' : chars[Math.floor(Math.random() * chars.length)];
      }
      el.textContent = scrambled;
      var iteration = 0;
      var interval = setInterval(function() {
        var decoded = '';
        for (var j = 0; j < length; j++) {
          if (j < iteration) {
            decoded += original[j];
          } else if (original[j] === ' ') {
            decoded += ' ';
          } else {
            decoded += chars[Math.floor(Math.random() * chars.length)];
          }
        }
        el.textContent = decoded;
        iteration += 1;
        if (iteration > length) {
          clearInterval(interval);
          el.textContent = original;
          el.classList.add('decoded');
        }
      }, 20);
    });
  }

  // ── Matrix / cipher rain on hero canvas ──
  function initMatrixRain() {
    var canvas = document.querySelector('[data-co-matrix]');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var parent = canvas.parentElement;
    function resize() {
      canvas.width = parent.offsetWidth;
      canvas.height = parent.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    var fontSize = 12;
    var columns = Math.floor(canvas.width / fontSize);
    var drops = [];
    for (var i = 0; i < columns; i++) {
      drops[i] = Math.random() * -100;
    }

    var glyphs = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン01';

    function draw() {
      ctx.fillStyle = 'rgba(7, 10, 18, 0.12)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#2FF6D2';
      ctx.font = fontSize + 'px JetBrains Mono, monospace';

      for (var j = 0; j < drops.length; j++) {
        var ch = glyphs[Math.floor(Math.random() * glyphs.length)];
        ctx.fillText(ch, j * fontSize, drops[j] * fontSize);

        if (drops[j] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[j] = 0;
        }
        drops[j] += 0.5;
      }
    }

    setInterval(draw, 50);
  }

  // ── Faction filter pills ──
  function initFactionFilters() {
    document.querySelectorAll('[data-co-faction-filter]').forEach(function(container) {
      var pills = container.querySelectorAll('.co-faction-pill');
      var panel = container.closest('.co-tab-panel') || container.closest('section');
      if (!panel) return;

      pills.forEach(function(pill) {
        pill.addEventListener('click', function() {
          pills.forEach(function(p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          var faction = pill.getAttribute('data-faction');
          var cards = panel.querySelectorAll('.co-product-card');
          cards.forEach(function(card) {
            if (faction === 'all') {
              card.style.display = '';
            } else {
              card.style.display = (card.getAttribute('data-co-faction') === faction) ? '' : 'none';
            }
          });
        });
      });
    });
  }

  function init() {
    try {
      bootstrapSettings();
      initTabs();
      initMobileNav();
      initDisconnect();
      initCartDrawer();
      initQuickView();
      initSort();
      initWishlist();
      // Skip heavy visual effects on low-end devices
      var isLowEnd = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        || (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2)
        || (navigator.deviceMemory && navigator.deviceMemory <= 2);

      if (!isLowEnd) {
        initTypewriter();
        initCipherDecode();
        initMatrixRain();
      }
      initFactionFilters();
      const btn = dom.gateButton();
      if (btn) {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          try {
            handleGate();
          } catch (err) {
            console.error("Error in button click handler:", err);
            setStatus(`⚠️ Error: ${err.message || "Unexpected error occurred"}\n\nPlease refresh the page and try again.`);
          }
        });
      }
      if (dom.gateStatus()) {
        setStatus("Connect your wallet to unlock Exclusive merch.");
      }

      // Auto-restore session cache on page load
      try {
        const cached = sessionStorage.getItem('co-nft-verified');
        if (cached) {
          state.account = cached;
          state.hasNft = true;
          toggleGatedContent(true);
          setStatus("Access granted – your owl is verified.");
          showDisconnectBtn(true);
        }
      } catch (e) {}
    } catch (err) {
      console.error("Error in init():", err);
      const statusEl = dom.gateStatus();
      if (statusEl) {
        setStatus(`⚠️ Initialization error\n\nPlease refresh the page.\n\nError: ${err.message || "Unknown error"}`);
      }
    }
  }

  // Suppress harmless MetaMask errors from WalletConnect (we only use Solana wallets)
  window.addEventListener('unhandledrejection', function(event) {
    const errorMsg = event.reason?.message || event.reason?.toString() || '';
    if (errorMsg.includes('MetaMask') || errorMsg.includes('metamask') || errorMsg.includes('Failed to connect to MetaMask')) {
      event.preventDefault(); // Suppress the error
      return false;
    }
  });

  // Wrap initialization in error handler to prevent breaking Shopify's scripts
  function safeInit() {
    try {
      init();
    } catch (err) {
      console.error("CipherOwls theme initialization error:", err);
      // Don't throw - allow Shopify's scripts to continue
    }
  }
  
  // Initialize immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", safeInit);
  } else {
    // DOM already loaded - initialize immediately
    // Use setTimeout to ensure it runs after other scripts
    setTimeout(safeInit, 0);
  }
  } catch (err) {
    // Catch any errors in the IIFE to prevent breaking Shopify's scripts
    console.error("CipherOwls theme script error:", err);
  }
})();
